import styled from '@emotion/styled/macro'
import { Box } from '@mui/material'
import { keyframes } from '@emotion/react'
import theme from 'theme'

const shimmer = keyframes`
  0% { transform: translateX(-100%); }
  100% { transform: translateX(800%); }
`

export const SkeletonBar = styled(Box)<{ width?: string }>`
  height: 20px;
  width: ${({ width }) => width || '100%'};
  background: ${theme.colors.labelCardBg};
  border: 1px solid ${theme.colors.borderMedium};
  border-radius: ${theme.attributes.borderRadius.secondary};
  overflow: hidden;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 27px;
    height: 100%;
    border-radius: ${theme.attributes.borderRadius.tertiary};
    background: linear-gradient(
      270deg,
      rgba(48, 40, 47, 0.5) 0%,
      rgba(87, 82, 86, 0.5) 50%,
      rgba(48, 40, 47, 0.5) 100%
    );
    animation: ${shimmer} 1.5s ease-in-out infinite;
  }

  /* Matches the dashboard loading state: light placeholder with a white sweep. */
  html[data-theme='light'] & {
    background: ${theme.colors.legacyPrimaryLight3};

    &::after {
      background: linear-gradient(
        270deg,
        rgba(252, 247, 251, 0) 0%,
        rgba(252, 247, 251, 0.9) 50%,
        rgba(252, 247, 251, 0) 100%
      );
    }
  }
`

export const MetaDataWrapper = styled(Box)`
  background: ${theme.colors.surfaceContainerBackground};
  border-radius: ${theme.attributes.borderRadius.tertiary};
  padding: ${theme.spacing.medium}px;
  display: flex;
  flex-direction: column;
  min-height: 332px;
  box-sizing: border-box;

  .section-title {
    display: flex;
    align-items: center;
    gap: ${theme.spacing.xSmall}px;
    margin-bottom: ${theme.spacing.small}px;

    .title-icon {
      width: 18px;
      height: 18px;
      color: ${theme.colors.menuItemText};
    }

    .title-text {
      font-family: ${theme.typography.fontFamily.primary};
      font-weight: ${theme.typography.fontWeight.bold};
      font-size: ${theme.typography.fontSize.header};
      color: ${theme.colors.menuItemText};

      html[data-theme='light'] & {
        color: #0b090a;
      }
    }
  }

  .meta-items {
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing.small}px;
  }

  .meta-item {
    display: flex;
    align-items: center;
    gap: ${theme.spacing.sm}px;

    .icon-box {
      width: 48px;
      height: 48px;
      min-width: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: ${theme.colors.devicesRowHoverBg};
      border-radius: ${theme.attributes.borderRadius.tertiary};

      svg {
        width: 18px;
        height: 18px;
        color: ${theme.colors.dropdownLabel};
      }
    }

    .meta-content {
      display: flex;
      flex-direction: column;
      gap: 4px;

      .meta-label {
        display: flex;
        align-items: center;
        gap: 4px;
        font-family: ${theme.typography.fontFamily.primary};
        font-weight: ${theme.typography.fontWeight.normal};
        font-size: ${theme.typography.fontSize.large};
        color: ${theme.colors.devicesSecondaryText};
        line-height: 22px;

        .info-icon-wrapper {
          display: flex;
          cursor: default;
          color: #6C5B67;

          &:hover {
            color: ${theme.colors.buttonHollowHover};
          }
        }
      }

      .meta-value {
        font-family: ${theme.typography.fontFamily.primary};
        font-weight: ${theme.typography.fontWeight.bold};
        font-size: ${theme.typography.fontSize.large};
        color: ${theme.colors.menuItemText};
        line-height: 20px;
      }
    }
  }
`
